import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "../css/event.css";
import { motion } from "framer-motion";
import javarush from "../javarush.jpeg";
import logicflip from "../logicflip.webp";
import css from "../clashofcss.png";
import hunt from "../hunt.jpeg";
import logicll from "../logicll.jpg";
import baloon from "../baloon.jpg";
import poster from "../poster.png";
import paper from "../paper.jpeg"



const events = [
  {
    name: "Paper Presentation",
    Venue: "CSE Conference Hall 1,,CSE Conference Hall 2,,D2 Hall  ",
    time: "FN",
    date: "March 3, 2025",
    image: paper,
    description: "Present your research or innovative ideas through a well-structured paper. Each presentation will be judged based on clarity, originality, and the depth of content."
  },
  {
    name: "Poster Panaroma",
    Venue: "Programming lab",
    time: "AN",
    date: "March 3, 2025",
    image: poster,
    description: `Poster Panorama is a two-round competition designed to test creativity and design skills. In Round 1 (Prelims), teams of two members will qualify for the final round. In Round 2 (Poster Making), participants will use Canva to design a visually appealing poster within 30 minutes.

          Posters must be original, creative, and visually engaging, with minimal yet impactful text. The judging criteria include content relevance, creativity, design quality, and visual appeal. AI-generated or plagiarized content is strictly prohibited. The best designs will be awarded exciting cash prizes! (Team of 2)`
  },
  {
    name: "Logic Flip",
    Venue: "MAD LAB",
    time: "FN",
    date: "March 3, 2025",
    image: logicflip,
    description: "Crack the hidden logic behind mysterious outputs! Decode and implement the logic in any programming language without hints. Your code must pass all test cases to succeed! (Team of 2)"
  },
  {
    name: "Clash of CSS",
    Venue: "Cloud lab",
    time: "FN",
    date: "March 3, 2025",
    image: css,
    description: "A two-round frontend battle! First, replicate a given UI design with pixel-perfect precision using only HTML & CSS. Then, design a unique UI for a given problem statement. Creativity, responsiveness, and attention to detail are key! (Team of 2)"
  },
  {
    name: "The Lost Code Quest",
    Venue: "Cloud lab",
    time: "AN",
    date: "March 3, 2025",
    image: hunt,
    description: "The Lost Code Quest-A wild, fun-filled challenge where teams crack puzzles in unexpected ways! One teammate sketches secret words while the other guesses—no talking, just doodles! Then, tackle a scrambled mess of instructions, hidden logic, and a tricky input. Piece it together, decode the logic, and unveil the answer before time runs out! (Team of 2)"
  },
  {
    name: "Logic League",
    Venue: "Programming lab",
    time: "FN",
    date: "March 3, 2025",
    image: logicll,
    description: "Put your logical reasoning and problem-solving skills to the test! Solve logic-based questions in Prelims and advance to real-world coding challenges in the Finals. The fastest and most accurate team wins! (Team of 2)"
  },
  {
    name: "Lexicon",
    Venue: "EDUSAT Hall",
    time: "AN",
    date: "March 3, 2025",
    image: baloon,
    description: "A thrilling and laughter-filled game where quick thinking meets technical expertise! Teams of two must decode technical terms through clever clues and a unique balloon-tapping challenge. Precision, teamwork, and fast reflexes will determine the ultimate champion!"
  }
];

const EventsPage = () => {
  useEffect(() => {
    document.title = "Events - Kreative";
  }, []);

  const [expandedIndex, setExpandedIndex] = useState(null);
  const navigate = useNavigate(); // Hook to navigate back

  return (
    <div className="events-container">
      {/* Back Button */}
      <button className="custom-btn neon-button" onClick={() => navigate(-1)}>
        ← Back
      </button>

      <h1 className="page-title">Events</h1>
      <div className="events-list">
        {events.map((event, index) => (
          <motion.div 
            key={index} 
            className={`event-card ${index % 2 === 0 ? "left" : "right"}`} 
            initial={{ opacity: 0, x: index % 2 === 0 ? -150 : 150 }} 
            whileInView={{ opacity: 1, x: 0 }} 
            viewport={{ once: true }} 
            transition={{ duration: 0.6, delay: index * 0.2 }}
            whileHover={{ scale: 1.1, rotate: 2 }}
          >
            <motion.img 
              src={event.image} 
              alt={event.name} 
              className="event-image"
              initial={{ filter: "brightness(70%)" }}
              whileHover={{ filter: "brightness(100%)", scale: 1.08 }}
              transition={{ duration: 0.3 }}
            />
            <h2 className="event-name">{event.name}</h2>
            <p className="event-info">
  📍 {event.Venue.split(",").map((place, index) => (
    <span key={index}>{place.trim()} <br /></span>
  ))}
</p>

            <p className="event-info">🕒 {event.time}</p>
            <p className="event-info">📅 {event.date}</p>
            <button 
              className="know-more-btn neon-button" 
              onClick={() => setExpandedIndex(expandedIndex === index ? null : index)}
            >
              {expandedIndex === index ? "Show Less" : "Know More"}
            </button>
            {expandedIndex === index && (
              <motion.div 
                className="event-details neon-box"
                initial={{ opacity: 0, y: -20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4 }}
              >
                <p>{event.description}</p>
              </motion.div>
            )}
          </motion.div>
        ))}
      </div>
       
      <section className="guidelines-section">
        <h2 className="neon-text">Event Guidelines</h2>
        <ul>
          <li>📌 The registration deadline closed on 28.02.2025.</li>
          <li>📌 Certificates will be provided for participants.</li>
          <li>📌Registration Fee:250Rs</li>
          <li>📌 No on-spot registration.</li>
          <li>📌 Bring your ID card for verification.</li>
          <li>📌 Follow all event schedules strictly.</li>
          <li>📌 Maintain decorum during the events.</li>

        </ul>
      </section>

      <div className="register-container">
        <Link to="https://forms.office.com/r/cS4e1UJi4q" className="register-btn neon-button">
          Register Now
        </Link>
      </div>

      <section className="location-section">
        <h2 className="neon-text">Find Us Here</h2>
        <iframe
          title="college-location"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1922.1190449750038!2d77.96359510533931!3d9.672608234748132!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3b012a8e3d378b53%3A0x15d8265b00bea0df!2sKamaraj%20College%20of%20Engineering%20%26%20Technology%20(Autonomous)!5e1!3m2!1sen!2sin!4v1739038113026!5m2!1sen!2sin"
          width="100%" 
          height="400px" 
          style={{ border: "0" }} 
          allowFullScreen 
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </section>
    </div>
  );
};

export default EventsPage;
